import React, { useState, useEffect } from 'react';
import Page from '../../layouts/Page';
import styles from './styles.module.sass';
import { hostname } from '../../constants';

interface PageContent {
  content: { rendered: string };
}

const Press: React.FC = () => {
  const [data, setData] = useState<PageContent | null>(null);

  useEffect(() => {
    fetch(`${hostname}/wp-json/wp/v2/pages/73560`)
      .then(res => res.json())
      .then((json: PageContent) => setData(json))
      .catch(console.error);
  }, []);

  if (!data?.content?.rendered) return null;

  return (
    <Page className={styles.base}>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: data.content.rendered }}
      />
    </Page>
  );
};

export default Press;
